import { render, staticRenderFns } from "./list-page.vue?vue&type=template&id=66dbb38d&"
import script from "./list-page.vue?vue&type=script&lang=ts&"
export * from "./list-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\viva-park\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66dbb38d')) {
      api.createRecord('66dbb38d', component.options)
    } else {
      api.reload('66dbb38d', component.options)
    }
    module.hot.accept("./list-page.vue?vue&type=template&id=66dbb38d&", function () {
      api.rerender('66dbb38d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/list-page/list-page.vue"
export default component.exports